import React from 'react';
import ThemedBlock from 'components/atoms/ThemedBlock'
import { colorList } from 'utils/colors'
import * as Progress from 'react-native-progress';
import Text from "theme/Text";
import _ from "lodash";
import { ThemedLoaderStyles } from 'styles/components/atoms/ThemedLoader'

const ThemedLoader = ({ text }) => {
	return (
		<ThemedBlock
			shadow
			mediumPadding
			style={ ThemedLoaderStyles.themedBlock }>
			
			{ !_.isEmpty( text ) && (
				<Text
					style={ ThemedLoaderStyles.text }>
					{text}
				</Text>
			)}
			
			<Progress.Bar
				height={4}
				width={200}
				animated={ true }
				color={ colorList.ORANGE.light }
				borderWidth={ 1 }
				indeterminate={true}
			/>
		</ThemedBlock>
	)
}

export default ThemedLoader
